import { SeverityTypeEnum } from '../enums/severity-type.enum';
import { AlertContextEnum } from '../enums/alert-context.enum';

export class AlertMessageModel {
  public target?: string;

  public constructor(public readonly severity: SeverityTypeEnum, public readonly context: AlertContextEnum, public readonly i18n: {
    fr: string,
    en: string
  }) {
  }

  getTranslatedMessage(language: string): string {
    if (!this.i18n.hasOwnProperty(language)) {
      return this.i18n.fr;
    }

    return this.i18n[language as 'fr' | 'en'];
  }
}